/**
 * Forms Layout - Dynamic page header for multi-page Gravity Forms
 */

(function () {
  const pageHeaders = {
    1: {
      title: "Thank you for your RSVP",
      description: "we hope to see you this november",
    },
    2: {
      title: "Guest Details",
      description:
        "Kindly share a photo and details for our guest list.",
    },
    3: {
      title: "Dietary Needs",
      description:
        "Kindly select your dietary restriction and note any allergies, etc.",
    },
    4: {
      title: "Accommodation Preferences",
      description: "Kindly select your preferred stay.",
    },
  };

  function updateFormHeader(pageNumber) {
    const header = document.getElementById("form-header");
    if (!header) return;

    const data = pageHeaders[pageNumber];
    if (!data) return;

    const h2 = header.querySelector("h2");
    const desc = header.querySelector("div");

    if (h2) h2.textContent = data.title;
    if (desc) desc.textContent = data.description;
  }

  // =========================================
  // FILE UPLOAD PREVIEW
  // =========================================

  function initFileUploadPreview() {
    var field = document.querySelector(".ct-field-fileupload");
    if (!field) return;

    var container = field.querySelector(".ginput_container_fileupload");
    if (!container) return;

    var input = container.querySelector('input[type="file"]');
    if (!input) return;

    // Clean up any existing preview (idempotent)
    removePreview(field, container);

    input.addEventListener("change", function () {
      if (!input.files || !input.files[0]) return;

      var file = input.files[0];

      // Only preview images
      if (file.type.startsWith("image/")) {
        var reader = new FileReader();
        reader.onload = function (e) {
          showPreview(field, container, e.target.result, file.name);
        };
        reader.readAsDataURL(file);
      } else {
        showPreview(field, container, null, file.name);
      }
    });
  }

  function showPreview(field, container, imageSrc, fileName) {
    // Remove any existing preview DOM only — don't clear the file input
    removePreview(field, container, false);

    var preview = document.createElement("div");
    preview.className = "ct-upload-preview";

    if (imageSrc) {
      var img = document.createElement("img");
      img.className = "ct-upload-preview__image";
      img.src = imageSrc;
      img.alt = fileName;
      preview.appendChild(img);
    }

    var name = document.createElement("span");
    name.className = "ct-upload-preview__filename";
    name.textContent = fileName;
    preview.appendChild(name);

    var removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "ct-upload-preview__remove";
    removeBtn.textContent = "Remove";
    removeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      e.preventDefault();
      removePreview(field, container);
    });
    preview.appendChild(removeBtn);

    container.appendChild(preview);
    field.classList.add("has-file");
  }

  function removePreview(field, container, clearInput) {
    var existing = container.querySelector(".ct-upload-preview");
    if (existing) {
      existing.remove();
    }

    if (clearInput !== false) {
      var input = container.querySelector('input[type="file"]');
      if (input) {
        input.value = "";
      }
    }

    field.classList.remove("has-file");
  }

  // =========================================
  // EVENT BINDINGS
  // =========================================

  // Gravity Forms fires this jQuery event when navigating between pages
  jQuery(document).on("gform_page_loaded", function (event, formId, currentPage) {
    updateFormHeader(currentPage);
    if (currentPage == 2) {
      initFileUploadPreview();
    }
  });

  // Also init on DOMContentLoaded for validation-return-to-page-2 scenarios
  document.addEventListener("DOMContentLoaded", function () {
    initFileUploadPreview();
  });
})();
